import React, {useEffect, useRef, useState} from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';

import * as constants from 'constants/index.js';
import CardsHeader from 'layouts/Headers/CardsHeader.js';

import TableCustom from 'views/pages/components/TableCustom';

import {Card, CardBody, CardHeader, Col, Container, Row,} from 'reactstrap';
import notify from '@utils/notify';

export default function Notifications() {
  const [loading, setLoading] = useState(true);
  const [notifications, setNotifications] = useState([]);
  const [activeStatus, setActiveStatus] = useState('');

  useEffect(() => {
    const grs_token = Cookies.get('grs_token')

    const source = axios.CancelToken.source()

    const fetchData = async () => {
      try {
        const response = await axios({
          method: 'GET',
          url: `${constants.API_URL}/all-notifications`,
          headers: {
            Authorization: `Bearer ${grs_token}`,
          },
          cancelToken: source.token,
        })
        console.log('response :: ', response.data)
        const data = response.data
        setNotifications(data.data.items)
        setActiveStatus(data.data.activeStatus)
        setLoading(false)
      } catch (error) {
        setLoading(false)
        if (axios.isCancel(error)) {
          console.log('Request canceled :: ', error)
        } else {
          console.error('error :: ', error)
          notify.warning(error.response.data.message || error.response.statusText)
        }
      }
    }

    fetchData()

    return () => {
      source.cancel()
    }
  }, [])

  return (
    <>
      <CardsHeader name="Notifications" parentName="Notifications Management" currentName="List" />
      <Container className="mt--5 admin-main-body" fluid >
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <div className="d-flex justify-content-between">
                  <div>
                    <h1 className="title mb-0">Notifications</h1>
                  </div>
                </div>
              </CardHeader>			  
              <CardBody>
                <TableCustom 
                  loading={loading}
                  keyField={`created_at`}
                  searchField={true}
                  items={notifications}
                  columns={[
                    {
                      dataField: "message",
                      text: "Name",
                      sort: true
                    },
                    {
                      dataField: "state",
                      text: "Is Active",
                      sort: true,
                      formatter: (rowContent, row) => {
                        return (
                          <span className={`badge badge-${row.state ? 'success' : 'dark'}`}>{activeStatus[row.state? 1: 0]}</span>
                        )
                      }
                    },
                    {
                      dataField: "created_at",
                      text: "Created at",
                      sort: true,
                      formatter: (rowContent, row) => {
                        return constants.formatDateShortGB(row.created_at);
                      }
                    }
                  ]}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  )
}